// import { deepClone } from '@ups/xplat/utils';

export class BaseModel {
  constructor(o: unknown = null) {
    if (o) {
      Object.assign(this, o);
      // Object.assign(this, deepClone(o));
    }
  }
}

/**
 * WI 35894: a subclass field initializer (`Files: FileDataModel[] = []`) runs AFTER BaseModel's constructor, so it
 * overwrites the value just assigned from `o`. A subclass that initializes a field calls `assignInput(this, o)` first
 * in its own constructor, which runs after its initializers, so a passed value wins and the initializer stays the
 * default. A module function, not a method: any instance member on BaseModel becomes required on every object
 * literal typed as a DTO (TS2741, PR 6183 review).
 */
export function assignInput(target: object, o: unknown): void {
  if (o) {
    Object.assign(target, o);
  }
}
